import { Injectable } from '@angular/core';

import { OnDemandPublicTrip, Product, RidangoReduxAction } from '@ridango/core';
import { StopData } from '../ride-planner.model';

export interface RidePlannerCredentials {
    startDate: any;
    coordinates: any;
}

@Injectable()
export class RidePlannerActions {
    static SET_PLAN = '[Ride Planner]: Set plan data';
    static SET_STEP = '[Ride Planner]: Set step';
    static SET_PASSENGER = '[Ride Planner]: Set passenger';
    static SET_ADDITIONAL_INFORMATION = '[Ride Planner]: Set Additional Information';
    static SET_PAYMENT_TYPE = '[Ride Planner]: Set Payment type';
    static SET_IS_RETURN = '[Ride Planner]: Set Return';
    static SET_PRODUCT_ID = '[Ride Planner]: Set Product Id';
    static SET_ESTIMATED_PRICE = '[Ride Planner]: Set Estimated Price';

    static FETCH_ESTIMATED_PRICE = '[Ride Planner] Fetch Estimated Price';
    static FETCH_ESTIMATED_PRICE_SUCCESS = '[Ride Planner] Fetch Estimated Price Success';
    static FETCH_ESTIMATED_PRICE_FAILED = '[Ride Planner] Fetch Estimated Price Failed';

    static FETCH_PRODUCTS = '[Ride Planner]: Fetch Products';
    static FETCH_PRODUCTS_SUCCESS = '[Ride Planner]: Fetch Products Success';
    static FETCH_PRODUCTS_FAILED = '[Ride Planner]: Fetch Products Failed';

    static POST_BOOKING_FLOW = '[Ride Planner] Post Booking Flow';
    static POST_BOOKING_FLOW_SUCCESS = '[Ride Planner] Post Booking Flow Success';
    static POST_BOOKING_FLOW_FAILED = '[Ride Planner] Post Booking Flow Failed';

    static RESET_SPECIFICATION = '[Ride Planner] Reset specification';

    static FETCH_POTENTIAL_STOPS = '[Ride Planner]: Fetch Potential Stops';
    static FETCH_POTENTIAL_STOPS_SUCCESS = '[Ride Planner]: Fetch Potential Stops Success';
    static FETCH_POTENTIAL_STOPS_FAILED = '[Ride Planner]: Fetch Potential Stops Failed';

    static FETCH_FILTERED_STOPS = '[Ride Planner]: Fetch Filtered Potential Stops';
    static FETCH_FILTERED_STOPS_SUCCESS = '[Ride Planner]: Fetch Filtered Potential Stops Success';
    static FETCH_FILTERED_STOPS_FAILED = '[Ride Planner]: Fetch Filtered Potential Stops Failed';

    setPlan(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_PLAN,
            payload: payload,
        };
    }

    setStep(step: number): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_STEP,
            payload: step,
        };
    }

    setPassenger(passenger: number): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_PASSENGER,
            payload: passenger,
        };
    }

    setProductId(productId: string): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_PRODUCT_ID,
            payload: productId,
        };
    }

    setEstimatedPrice(price: number): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_ESTIMATED_PRICE,
            payload: price,
        };
    }

    setAdditionalInformation(information: string): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_ADDITIONAL_INFORMATION,
            payload: information,
        };
    }

    setIsInvoice(payment: boolean): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_PAYMENT_TYPE,
            payload: payment,
        };
    }

    setIsReturn(payload: boolean): RidangoReduxAction {
        return {
            type: RidePlannerActions.SET_IS_RETURN,
            payload: payload,
        };
    }

    fetchEstimatedPrice(payload: RidePlannerCredentials): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_ESTIMATED_PRICE,
            payload: payload,
        };
    }

    fetchEstimatedPriceSuccess(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_ESTIMATED_PRICE_SUCCESS,
            payload: payload,
        };
    }

    fetchEstimatedPriceFailed(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_ESTIMATED_PRICE_FAILED,
            payload: payload,
        };
    }

    fetchProducts(): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_PRODUCTS,
        };
    }

    fetchProductsSuccess(payload: Product[]): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_PRODUCTS_SUCCESS,
            payload: payload,
        };
    }

    fetchProductsFailed(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_PRODUCTS_FAILED,
            payload: payload,
        };
    }

    postBookingFlow(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.POST_BOOKING_FLOW,
            payload: payload,
        };
    }

    postBookingFlowSuccess(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.POST_BOOKING_FLOW_SUCCESS,
            payload: payload,
        };
    }

    postBookingFlowFailed(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.POST_BOOKING_FLOW_FAILED,
            payload: payload,
        };
    }

    resetSpecification(): RidangoReduxAction {
        return {
            type: RidePlannerActions.RESET_SPECIFICATION,
        };
    }

    fetchPotentialStops(payload: string): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_POTENTIAL_STOPS,
            payload
        };
    }

    fetchPotentialStopsSuccess(payload: StopData[]): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_POTENTIAL_STOPS_SUCCESS,
            payload: payload,
        };
    }

    fetchPotentialStopsFailed(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_POTENTIAL_STOPS_FAILED,
            payload: payload,
        };
    }

    fetchFilteredPotentialStops(payload: string): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_FILTERED_STOPS,
            payload
        };
    }

    fetchFilteredPotentialStopsSuccess(payload: StopData[]): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_FILTERED_STOPS_SUCCESS,
            payload: payload,
        };
    }

    fetchFilteredPotentialStopsFailed(payload): RidangoReduxAction {
        return {
            type: RidePlannerActions.FETCH_FILTERED_STOPS_FAILED,
            payload: payload,
        };
    }
}
